/* eslint-disable import/prefer-default-export */
export async function resolveStyleImport(brand) {
  await import(`../../js/forms/themes/${brand}.scss`);
  await import('../forms/themes/shared.scss');
}
